/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateIndividualProjectdossierDto } from '../models/work-create-individual-projectdossier-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkProjectdossierContentDto } from '../models/work-projectdossier-content-dto';
import { WorkProjectdossierDto } from '../models/work-projectdossier-dto';
import { WorkUpdateIndividualProjectdossierDto } from '../models/work-update-individual-projectdossier-dto';
import { WorkUpdateProjectdossierDocumentselectionDto } from '../models/work-update-projectdossier-documentselection-dto';
import { WorkUpdateProjectdossierHiddenDocumentsDto } from '../models/work-update-projectdossier-hidden-documents-dto';

@Injectable({ providedIn: 'root' })
export class WorkProjectdossiersV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectdossiersV2ControllerFindByProjectId()` */
  static readonly ProjectdossiersV2ControllerFindByProjectIdPath = '/v2/projectdossiers/by-project/{projectId}';

  /**
   * Required permissions: projects:read, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerFindByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerFindByProjectId$Response(
    params: {
      projectId: number;

    /**
     * Auch im Projekt ausgeblendete Dossiers zurückgeben
     */
      includeHidden?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProjectdossierDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerFindByProjectIdPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.query('includeHidden', params.includeHidden, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProjectdossierDto>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerFindByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerFindByProjectId(
    params: {
      projectId: number;

    /**
     * Auch im Projekt ausgeblendete Dossiers zurückgeben
     */
      includeHidden?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<WorkProjectdossierDto>> {
    return this.projectdossiersV2ControllerFindByProjectId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProjectdossierDto>>): Array<WorkProjectdossierDto> => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerGetAvailableTemplates()` */
  static readonly ProjectdossiersV2ControllerGetAvailableTemplatesPath = '/v2/projectdossiers/by-project/{projectId}/available-templates';

  /**
   * Required permissions: projects:read, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerGetAvailableTemplates()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerGetAvailableTemplates$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerGetAvailableTemplatesPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerGetAvailableTemplates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerGetAvailableTemplates(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.projectdossiersV2ControllerGetAvailableTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerFindOne()` */
  static readonly ProjectdossiersV2ControllerFindOnePath = '/v2/projectdossiers/by-project/{projectId}/template/{templateId}';

  /**
   * Required permissions: projects:read, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerFindOne$Response(
    params: {
      projectId: number;
      templateId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerFindOnePath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('templateId', params.templateId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerFindOne(
    params: {
      projectId: number;
      templateId: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierDto> {
    return this.projectdossiersV2ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierDto>): WorkProjectdossierDto => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerAddFromTemplate()` */
  static readonly ProjectdossiersV2ControllerAddFromTemplatePath = '/v2/projectdossiers/by-project/{projectId}/template/{templateId}';

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerAddFromTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerAddFromTemplate$Response(
    params: {
      projectId: number;
      templateId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerAddFromTemplatePath, 'post');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('templateId', params.templateId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierDto>;
      })
    );
  }

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerAddFromTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerAddFromTemplate(
    params: {
      projectId: number;
      templateId: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierDto> {
    return this.projectdossiersV2ControllerAddFromTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierDto>): WorkProjectdossierDto => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerRemove()` */
  static readonly ProjectdossiersV2ControllerRemovePath = '/v2/projectdossiers/by-project/{projectId}/template/{templateId}';

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerRemove$Response(
    params: {
      projectId: number;
      templateId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerRemovePath, 'delete');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('templateId', params.templateId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerRemove(
    params: {
      projectId: number;
      templateId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.projectdossiersV2ControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerGetContent()` */
  static readonly ProjectdossiersV2ControllerGetContentPath = '/v2/projectdossiers/by-project/{projectId}/template/{templateId}/content';

  /**
   * Required permissions: projects:read, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerGetContent()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerGetContent$Response(
    params: {
      projectId: number;
      templateId: number;

    /**
     * Auch die im Projekt auf Dokument-Ebene ausgeblendeten Dokumente zurückgeben. Für die Konfigurationsansicht, in der die Projektleitung die Sichtbarkeit einzelner Dokumente setzt.
     */
      includeHiddenDocuments?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierContentDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerGetContentPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('templateId', params.templateId, {});
      rb.query('includeHiddenDocuments', params.includeHiddenDocuments, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierContentDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerGetContent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerGetContent(
    params: {
      projectId: number;
      templateId: number;

    /**
     * Auch die im Projekt auf Dokument-Ebene ausgeblendeten Dokumente zurückgeben. Für die Konfigurationsansicht, in der die Projektleitung die Sichtbarkeit einzelner Dokumente setzt.
     */
      includeHiddenDocuments?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierContentDto> {
    return this.projectdossiersV2ControllerGetContent$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierContentDto>): WorkProjectdossierContentDto => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerCreateIndividual()` */
  static readonly ProjectdossiersV2ControllerCreateIndividualPath = '/v2/projectdossiers/by-project/{projectId}/individual';

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerCreateIndividual()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossiersV2ControllerCreateIndividual$Response(
    params: {
      projectId: number;
      body: WorkCreateIndividualProjectdossierDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerCreateIndividualPath, 'post');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierDto>;
      })
    );
  }

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerCreateIndividual$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossiersV2ControllerCreateIndividual(
    params: {
      projectId: number;
      body: WorkCreateIndividualProjectdossierDto
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierDto> {
    return this.projectdossiersV2ControllerCreateIndividual$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierDto>): WorkProjectdossierDto => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerFindOneIndividual()` */
  static readonly ProjectdossiersV2ControllerFindOneIndividualPath = '/v2/projectdossiers/by-project/{projectId}/individual/{projectdossierId}';

  /**
   * Required permissions: projects:read, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerFindOneIndividual()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerFindOneIndividual$Response(
    params: {
      projectId: number;
      projectdossierId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerFindOneIndividualPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('projectdossierId', params.projectdossierId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerFindOneIndividual$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerFindOneIndividual(
    params: {
      projectId: number;
      projectdossierId: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierDto> {
    return this.projectdossiersV2ControllerFindOneIndividual$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierDto>): WorkProjectdossierDto => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerRemoveIndividual()` */
  static readonly ProjectdossiersV2ControllerRemoveIndividualPath = '/v2/projectdossiers/by-project/{projectId}/individual/{projectdossierId}';

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerRemoveIndividual()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerRemoveIndividual$Response(
    params: {
      projectId: number;
      projectdossierId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerRemoveIndividualPath, 'delete');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('projectdossierId', params.projectdossierId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerRemoveIndividual$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerRemoveIndividual(
    params: {
      projectId: number;
      projectdossierId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.projectdossiersV2ControllerRemoveIndividual$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerUpdateIndividual()` */
  static readonly ProjectdossiersV2ControllerUpdateIndividualPath = '/v2/projectdossiers/by-project/{projectId}/individual/{projectdossierId}';

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerUpdateIndividual()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossiersV2ControllerUpdateIndividual$Response(
    params: {
      projectId: number;
      projectdossierId: number;
      body: WorkUpdateIndividualProjectdossierDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerUpdateIndividualPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('projectdossierId', params.projectdossierId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierDto>;
      })
    );
  }

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerUpdateIndividual$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossiersV2ControllerUpdateIndividual(
    params: {
      projectId: number;
      projectdossierId: number;
      body: WorkUpdateIndividualProjectdossierDto
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierDto> {
    return this.projectdossiersV2ControllerUpdateIndividual$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierDto>): WorkProjectdossierDto => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerGetIndividualContent()` */
  static readonly ProjectdossiersV2ControllerGetIndividualContentPath = '/v2/projectdossiers/by-project/{projectId}/individual/{projectdossierId}/content';

  /**
   * Required permissions: projects:read, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerGetIndividualContent()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerGetIndividualContent$Response(
    params: {
      projectId: number;
      projectdossierId: number;

    /**
     * Auch die im Projekt auf Dokument-Ebene ausgeblendeten Dokumente zurückgeben. Für die Konfigurationsansicht, in der die Projektleitung die Sichtbarkeit einzelner Dokumente setzt.
     */
      includeHiddenDocuments?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierContentDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerGetIndividualContentPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('projectdossierId', params.projectdossierId, {});
      rb.query('includeHiddenDocuments', params.includeHiddenDocuments, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierContentDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerGetIndividualContent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerGetIndividualContent(
    params: {
      projectId: number;
      projectdossierId: number;

    /**
     * Auch die im Projekt auf Dokument-Ebene ausgeblendeten Dokumente zurückgeben. Für die Konfigurationsansicht, in der die Projektleitung die Sichtbarkeit einzelner Dokumente setzt.
     */
      includeHiddenDocuments?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierContentDto> {
    return this.projectdossiersV2ControllerGetIndividualContent$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierContentDto>): WorkProjectdossierContentDto => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerUpdateIndividualHiddenDocuments()` */
  static readonly ProjectdossiersV2ControllerUpdateIndividualHiddenDocumentsPath = '/v2/projectdossiers/by-project/{projectId}/individual/{projectdossierId}/hidden-documents';

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerUpdateIndividualHiddenDocuments()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossiersV2ControllerUpdateIndividualHiddenDocuments$Response(
    params: {
      projectId: number;
      projectdossierId: number;
      body: WorkUpdateProjectdossierHiddenDocumentsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerUpdateIndividualHiddenDocumentsPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('projectdossierId', params.projectdossierId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierDto>;
      })
    );
  }

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerUpdateIndividualHiddenDocuments$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossiersV2ControllerUpdateIndividualHiddenDocuments(
    params: {
      projectId: number;
      projectdossierId: number;
      body: WorkUpdateProjectdossierHiddenDocumentsDto
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierDto> {
    return this.projectdossiersV2ControllerUpdateIndividualHiddenDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierDto>): WorkProjectdossierDto => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerUpdateDocumentselection()` */
  static readonly ProjectdossiersV2ControllerUpdateDocumentselectionPath = '/v2/projectdossiers/by-project/{projectId}/template/{templateId}/documentselection';

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerUpdateDocumentselection()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossiersV2ControllerUpdateDocumentselection$Response(
    params: {
      projectId: number;
      templateId: number;
      body: WorkUpdateProjectdossierDocumentselectionDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerUpdateDocumentselectionPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('templateId', params.templateId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierDto>;
      })
    );
  }

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerUpdateDocumentselection$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossiersV2ControllerUpdateDocumentselection(
    params: {
      projectId: number;
      templateId: number;
      body: WorkUpdateProjectdossierDocumentselectionDto
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierDto> {
    return this.projectdossiersV2ControllerUpdateDocumentselection$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierDto>): WorkProjectdossierDto => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerUpdateHiddenDocuments()` */
  static readonly ProjectdossiersV2ControllerUpdateHiddenDocumentsPath = '/v2/projectdossiers/by-project/{projectId}/template/{templateId}/hidden-documents';

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerUpdateHiddenDocuments()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossiersV2ControllerUpdateHiddenDocuments$Response(
    params: {
      projectId: number;
      templateId: number;
      body: WorkUpdateProjectdossierHiddenDocumentsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerUpdateHiddenDocumentsPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('templateId', params.templateId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierDto>;
      })
    );
  }

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerUpdateHiddenDocuments$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossiersV2ControllerUpdateHiddenDocuments(
    params: {
      projectId: number;
      templateId: number;
      body: WorkUpdateProjectdossierHiddenDocumentsDto
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierDto> {
    return this.projectdossiersV2ControllerUpdateHiddenDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierDto>): WorkProjectdossierDto => r.body)
    );
  }

  /** Path part for operation `projectdossiersV2ControllerResetToTemplate()` */
  static readonly ProjectdossiersV2ControllerResetToTemplatePath = '/v2/projectdossiers/by-project/{projectId}/template/{templateId}/reset-to-template';

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossiersV2ControllerResetToTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerResetToTemplate$Response(
    params: {
      projectId: number;
      templateId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossiersV2Service.ProjectdossiersV2ControllerResetToTemplatePath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('templateId', params.templateId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierDto>;
      })
    );
  }

  /**
   * Required permissions: projectdossiers:update, projectdossiers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossiersV2ControllerResetToTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossiersV2ControllerResetToTemplate(
    params: {
      projectId: number;
      templateId: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierDto> {
    return this.projectdossiersV2ControllerResetToTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierDto>): WorkProjectdossierDto => r.body)
    );
  }

}
